var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Pane, SegmentedControl } from "evergreen-ui";
import ApoFieldLabel from "./ApoFieldLabel";
var ApoSegmentedControl = function (_a) {
    var value = _a.value, label = _a.label, required = _a.required, _b = _a.options, options = _b === void 0 ? [] : _b, onChange = _a.onChange, disabled = _a.disabled;
    if (!options[0] || !options[0].value)
        return null;
    return (_jsxs(Pane, __assign({ flex: 1, marginBottom: 10 }, { children: [label && _jsx(ApoFieldLabel, { required: required, value: label }), _jsx(SegmentedControl, { disabled: disabled, options: options, height: 45, value: value, onChange: onChange })] })));
};
export default ApoSegmentedControl;
